/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {useMutation, useQueryClient} from 'react-query'
// import {MenuComponent} from '../../../../../../../_metronic/assets/ts/components'
// import {ID, KTSVG, QUERIES} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import {deleteFloor} from '../../core/_requests'
import { MenuComponent } from '../../../../../../_metronic/assets/ts/components'
import { ID, KTSVG, QUERIES, toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import { useNavigate } from 'react-router-dom'
// import DeleteTenentsDetails from '../../../DeleteFloorDetails'
// import DeleteFloorsDetails from '../../../DeleteFloorDetails'
import { OverlayTrigger } from 'react-bootstrap'
import Tooltip from 'react-bootstrap/Tooltip';
import DeleteFloorsDetails from '../../../DeleteFloorDetails'
// import DeleteFloorsDetails from '../../../DeleteFloorDetails'
// import ViewFloorDetails from '../../../ViewFloorDetails'


type Props = {
  id: ID
}

const FloorActionsCell: FC<Props> = ({id}) => {
  const {setItemIdForUpdate} = useListView()
  const {query} = useQueryResponse()
  const queryClient = useQueryClient()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const openEditModal = () => {
    setItemIdForUpdate(id)
  }


  // const navigate = useNavigate()
  // const navigateViewFloorDetails = () => {
  //   // 👇️ navigate to /
  //   navigate(`/viewfloordetails`)
  // }


  // const deleteItem = useMutation(() => deleteFloor(id), {
  //   // 💡 response of the mutation is passed to onSuccess
  //   onSuccess: () => {
  //     // ✅ update detail view directly
  //     queryClient.invalidateQueries([`${QUERIES.UNITS_LIST}-${query}`])
  //   },
  // })


  const [ShowDeleteFloorDetails, setShowDeleteFloorDetails] = useState<boolean>(false)
  // const [ShowViewFloorDetails, setShowViewFloorDetails] = useState<boolean>(false)

  return (
    <>
      {/* <a
        href='#'
        className='btn btn-light btn-active-light-primary btn-sm'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        Actions
        <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 m-0' />
      </a> */}
      {/* begin::Menu */}

<div className='d-flex flex-wrap flex-end'>

{/* <div className='menu-item px-3'>
          <a className='menu-link p-1' onClick={() => setShowViewFloorDetails(true)}>
          <OverlayTrigger
              placement='top'
              overlay={<Tooltip className='py-2 px-2 fs-5 '>View</Tooltip>}
            >
          <i className="fa-sharp fa-solid fa-file-lines fs-5 text-info"></i>
          </OverlayTrigger>
          </a>
          <ViewFloorDetails
            show={ShowViewFloorDetails} handleClose={() => setShowViewFloorDetails(false)}
          /> 
        </div> */}

<div className='menu-item px-3'>
          <a className='menu-link p-1' onClick={openEditModal}>
          <OverlayTrigger
              placement='top'
              overlay={<Tooltip className='py-2 px-2 fs-5 '>Edit</Tooltip>}
            >
          <i className="fa-regular fa-pen-to-square fs-4 text-warning"></i>
          </OverlayTrigger>
          </a>
        </div>

        <div className='menu-item px-3'>
          <a className='menu-link p-1' onClick={() => setShowDeleteFloorDetails(true)} >
          <OverlayTrigger
              placement='top'
              overlay={<Tooltip className='py-2 px-2 fs-5 '>Delete</Tooltip>}
            >
          <i className="fa-solid fa-trash-can fs-4 text-danger"></i>
          </OverlayTrigger>
          </a>

           <DeleteFloorsDetails
           show={ShowDeleteFloorDetails} handleClose={() => setShowDeleteFloorDetails(false)}
          /> 
        </div>

</div>



      {/* end::Menu */}
    </>
  )
}

export {FloorActionsCell}
